import React from 'react';
import { NotificationBell, NotificationPanel } from '../../components/shell';
import Section from './Section';
import { sampleNotifications, sampleUnreadCount } from './notificationFixtures';

/**
 * /design — notification bell + panel states (`/design?only=notifications`):
 * badge at 0 (hidden — honest empty state), a small count, and the 99+ cap;
 * the panel with mixed read/unread rows and the empty state.
 */

const noop = () => undefined;

const BellState: React.FC<{ label: string; unreadCount: number }> = ({ label, unreadCount }) => (
  <div className="flex flex-col items-center gap-s2">
    <NotificationBell
      unreadCount={unreadCount}
      items={sampleNotifications}
      onSelect={noop}
      onMarkAllRead={noop}
    />
    <span className="text-meta text-ink-muted">{label}</span>
  </div>
);

const NotificationsGallery: React.FC = () => (
  <Section title="Notifications (bell + panel)">
    <div className="flex flex-col gap-s6">
      <div>
        <p className="mb-s3 text-row-title text-ink">Badge states (danger-toned, hidden at 0)</p>
        <div className="flex items-start gap-s7">
          <BellState label="0 unread" unreadCount={0} />
          <BellState label="3 unread" unreadCount={3} />
          <BellState label="120 unread → 99+" unreadCount={120} />
        </div>
      </div>
      <div>
        <p className="mb-s3 text-row-title text-ink">Panel states</p>
        <div className="flex flex-wrap items-start gap-s6">
          <div>
            <p className="mb-s2 text-meta text-ink-muted">Mixed rows (unread on the action wash)</p>
            <NotificationPanel
              items={sampleNotifications}
              unreadCount={sampleUnreadCount}
              onSelect={noop}
              onMarkAllRead={noop}
            />
          </div>
          <div>
            <p className="mb-s2 text-meta text-ink-muted">Empty (honest — nothing invented)</p>
            <NotificationPanel items={[]} unreadCount={0} onSelect={noop} onMarkAllRead={noop} />
          </div>
        </div>
      </div>
    </div>
  </Section>
);

export default NotificationsGallery;
